import mondaySdk from 'monday-sdk-js';
import { GRAPHQL_VERSION_BY_ACCOUNT_ID } from '@gorilla/spreadsheet-shared/src/consts';
import { decodeJwt } from './utils';

import { createMondaySdkRequester, createMondayClient } from '@gorilla/common/src/lib/monday-api/common';

function getAccountIdFromQuery() {
  try {
    // get session token from url query parameter
    const params = new URLSearchParams(window.location.search);
    const sessionToken = params.get('sessionToken');

    if (!sessionToken) {
      throw new Error('No session token in query params');
    }

    const payload = decodeJwt(sessionToken);

    return payload?.dat?.account_id || null;
  } catch (err) {
    console.log('Failed to get account id from query params', err);

    return null;
  }
}

export const monday = mondaySdk();

let graphQlVersion = '2025-07';

const accountId = getAccountIdFromQuery();

if (accountId && accountId in GRAPHQL_VERSION_BY_ACCOUNT_ID) {
  // @ts-ignore
  graphQlVersion = GRAPHQL_VERSION_BY_ACCOUNT_ID[accountId];
  console.log('Overriding GraphQL version to', graphQlVersion, 'for accountId', accountId);
}

monday.setApiVersion(graphQlVersion);

export async function getSessionToken() {
  return ((await monday.get('sessionToken')) as any).data;
}

export const mondayClient = createMondayClient(createMondaySdkRequester(monday));
